<section>

    <app-gjt></app-gjt>

    <body>
        <div class="container bd">
            <div class="row op">
                <div class="card" style="width: 18rem;">
                    <div class="card-body">
                      <h5 class="card-title">Nuevo Empleo</h5>
                      <h6 class="card-subtitle mb-2 text-muted">Nueva oferta</h6>
                      <p class="card-text">Se crea el nueva oferta, para que agregue nuevas oferta laborales, para los egresado del tecnológico.</p>
                      <a routerLink='/job-new' class="card-link">Crear</a>
                    </div>
                  </div>

                  <div class="card" style="width: 18rem;">
                    <div class="card-body">
                      <h5 class="card-title">Lista de Empleo</h5>
                      <h6 class="card-subtitle mb-2 text-muted">Ver editores</h6>
                      <p class="card-text">Aqui se encuentra todo las ofeta que se agregan, editan y elimina las oferta laborales</p>
                      <a routerLink='/jobs-list' class="card-link">Ver</a>
                    </div>
                  </div>
                  
            </div>
        </div>
    </body>

</section>